import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { TQuickAnswerForm } from "../QuickAnswerSchema";
import { useWatch } from "react-hook-form";
import MainApi from "../../../../../../../services/mainApi.service";

const TICKET_CHANNELS_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannels/";

const ticketChannelsService = new MainApi(TICKET_CHANNELS_ROUTE);

const translationPath = "page.settings.quickAnswer.";

export const TicketChannelSelector = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext<TQuickAnswerForm>();

  const currentShareType = useWatch({ name: "shareType", control });

  if (!currentShareType || currentShareType.code !== "3") return null;

  return (
    <Grid item xs={12} md={6}>
      <AutoComplete
        name="ticketChannel"
        label={t(translationPath + "ticket_channel")}
        size="small"
        fullWidth
        getOptionLabel={(option) => option.name}
        request={ticketChannelsService.list}
      />
    </Grid>
  );
});
